const AuthReducer = (state = {}, action) => {
    switch (action.type) {
      case "USER_LOGIN_REQUEST":
        return {
          user: null,
          loading: true,
          error: null,
        };
      case "USER_LOGIN_SUCCESS":
        return {
          user: action.payload,
          loading: false,
          error: null,
        };
      case "USER_LOGIN_FAILURE":
        return {
          user: null,
          loading: false,
          error: action.payload,
        };
      case "USER_LOGOUT":
        return {
          user: null,
          loading: false,
          error: null,
        };
      default:
        return state;
    }
  };
  
  export default AuthReducer;
  